export const albumsConstants = {
  ALBUMS_LOAD_DATA_REQUEST: 'ALBUMS_LOAD_DATA_REQUEST',
  ALBUMS_LOAD_DATA_SUCCESS: 'ALBUMS_LOAD_DATA_SUCCESS',
  ALBUMS_LOAD_DATA_FAILURE: 'ALBUMS_LOAD_DATA_FAILURE',

  ALBUMS_SET_SUBMENU: 'ALBUMS_SET_SUBMENU',
  ALBUMS_SET_DETAIL_ID: 'ALBUMS_SET_DETAIL_ID',
};